export const getCampaignDataStorePath = queryData => {
  let path;

  const { dataHierarchy, campaignId, dateType, type } = queryData;

  if (dataHierarchy === 'businessContext') {
    path = [dataHierarchy, type, dateType];
  }

  if (dataHierarchy === 'campaign') {
    path = [dataHierarchy, campaignId, type, dateType];
  }

  return path;
};
